export const IDS = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",
  logoutBtn: "logout-btn",
  navPrefix: "nav-",
  newProductBtn: "new-product-btn",
  newSupplierBtn: "new-supplier-btn",
  newCustomerBtn: "new-customer-btn",
  newVariantBtn: "new-variant-btn",
  newMovementBtn: "new-movement-btn",
  newOrderBtn: "new-order-btn",
  newCustomizationBtn: "new-customization-btn",
  modalSave: "modal-save-btn",
  modalCancel: "modal-cancel-btn",
  emailForm: "profile-email-form",
  passwordForm: "profile-password-form",
  backupExport: "backup-export-btn",
  backupImport: "backup-import-input",
  backupReset: "backup-reset-btn",
};
